import { useState } from "react";
import { observer } from "mobx-react";
import { PageKit } from "components/common/PageContainer/PageKit";
import { Store } from "state/store";
import { Menu } from "domain/menuOptions";
import { ExtendTerm } from "components/ExtendRemainingTerm";
import { Col } from "reactstrap";
import { EXTEND_TERM_ATTN_URL } from "App.const";
import {
  findRepaymentOption,
  RepaymentOptionType,
} from "domain/indicativeRepaymentOptions";
import { SelectedTreatmentsDetails } from "domain/selectedTreatments";
import { useNavigate } from "react-router-dom";
import { EXTEND_TERM_SCREEN_TITLE } from "./Title.const";
import { SiteDown } from "components/AppendixScreen/SiteDown";

export type ExtendTermScreenProps = {
  store: Store;
};

const ExtendTermScreen = ({ store }: ExtendTermScreenProps) => {
  document.title = EXTEND_TERM_SCREEN_TITLE;
  const { menuStore, indicativeRepaymentOptionsStore, fetching, error } = store;
  const navigate = useNavigate();
  const [confirmation, setConfirmation] = useState<boolean>(false);

  const getRepaymentOption = findRepaymentOption(
    store.indicativeRepaymentOptionsStore.data?.repaymentOptions || []
  );
  const extendTerm = getRepaymentOption(RepaymentOptionType.ExtendTerm);
  const existingLoanDetails =
    indicativeRepaymentOptionsStore.data?.existingLoanDetails;

  const selectedTreatments: SelectedTreatmentsDetails = {
    treatmentOptionType: Menu.ExtendTerm,
    selectedOptionType: extendTerm?.optionType || null,
    repaymentOption: extendTerm || null,
    existingLoanDetails: existingLoanDetails || null,
  };

  const handleClick = async () => {
    await store.selectedTreatmentStore.setSelectedTreatments(
      selectedTreatments
    );
    navigate(EXTEND_TERM_ATTN_URL, { replace: true });
  };

  if (store.hasInvalidNumberOfRepayments) {
    return (
      <>
        <PageKit selectedMenu={Menu.ExtendTerm} menus={menuStore.data} />
        <Col className="content-body">
          <SiteDown message="finalRepaymentDate is invalid" />
        </Col>
      </>
    );
  }

  return (
    <>
      <PageKit selectedMenu={Menu.ExtendTerm} menus={menuStore.data} />
      <Col className="content-body">
        <div className="extend-term stickyLandingContainer">
          {selectedTreatments.repaymentOption && (
            <ExtendTerm
              fetching={fetching}
              error={error}
              existingLoanDetails={
                indicativeRepaymentOptionsStore.existingLoanDetails
              }
              repaymentOption={selectedTreatments.repaymentOption}
              checked={confirmation}
              onChecked={setConfirmation}
              onProgress={handleClick}
            />
          )}
        </div>
      </Col>
    </>
  );
};

const ExtendTermScreenObserver = observer(ExtendTermScreen);
export { ExtendTermScreenObserver as ExtendTermScreen };
